import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import DraftIcon from "assets/icons/draft.svg?react";
import { useOnClickOutside } from "usehooks-ts";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const TemplateActiveModal: FC<Props> = ({ toggle, onRemove }) => {
  const { t } = useTranslation();
  const ref = useRef(null);
  useOnClickOutside(ref, () => {
    toggle(false);
  });

  const [, setMousePosition] = useState({ x: 0, y: 0 });

  const handleMouseMove = (event) => {
    const position = ref.current.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    const posY = event.clientY + position.height > windowHeight;

    setMousePosition({
      x: event.clientX,
      y: posY ? event.clientY - position.height : event.clientY,
    });
  };

  useEffect(() => {
    const currentEvent = window.event;
    if (currentEvent) {
      handleMouseMove(currentEvent);
    } else {
      // If no event available, add listener to capture the next move
      window.addEventListener("mousemove", handleMouseMove, { once: true });
    }

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <div ref={ref} className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.title}></div>
        <div
          onClick={() => {
            onRemove();
            toggle(false);
          }}
          className={styles.box}
        >
          <DraftIcon />
          {t("documents.removeFromTemplates")}
        </div>
      </div>
    </div>
  );
};

export default TemplateActiveModal;
